<div class="callback-container">
  <p>Procesando inicio de sesión...</p>
  <div class="spinner"></div>
</div>
